import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import AddIcon from "@material-ui/icons/Add";
import ClearIcon from "@material-ui/icons/Clear";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import Icon from "@material-ui/core/Icon";
import Popover from "@material-ui/core/Popover";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { Input } from ".";
import { formatMoney } from "../../utils/formatters";
import { getAmount } from "../../utils/orderUtils";
import { usePrefs } from "../../providers/Prefs";

const useStyles = makeStyles((theme) => ({
  root: {
    background: "#fff",
  },
  container: {
    display: "grid",
    gridTemplateColumns: "auto  140px 140px 140px 140px 40px",
    alignItems: "center",
    columnGap: 16,
    padding: 4,
  },
  center: {
    textAlign: "center",
  },
  right: {
    textAlign: "right",
  },
  buttonContainer: {
    padding: 4,
  },
  discountPickerRoot: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    "&:hover": {
      background: "#E4E4E4",
    },
  },
}));

export default function RetainerOrderItems({
  push,
  remove,
  form,
  products = [],
  priceKey,
}) {
  const classes = useStyles();

  const [discountPolicy, setDiscountPolicy] = React.useState("percent");

  React.useEffect(() => {
    const len = form.values?.items?.length ?? 0;
    for (let index = 0; index < len; index++) {
      form.setFieldValue(`items[${index}].discountType`, discountPolicy);
    }
    // eslint-disable-next-line
  }, [discountPolicy]);

  return (
    <div className={classes.root}>
      <div className={classes.container}>
        <Typography variant="button">Description</Typography>
        <Typography variant="button" className={classes.center}>
          Price
        </Typography>
        <Typography variant="button" className={classes.center}>
          Qty
        </Typography>
        <DiscountPicker onChange={setDiscountPolicy} />
        <Typography variant="button" className={classes.right}>
          Amount
        </Typography>

        <Typography></Typography>
      </div>

      <Divider />

      {form.values?.items?.map((item, index) => (
        <React.Fragment key={index}>
          <div className={classes.container}>
            <Input
              name={`items[${index}].description`}
              bottom={0}
              width={500}
            />
            <Input
              name={`items[${index}].salesPrice`}
              type="number"
              bottom={0}
            />
            <Input name={`items[${index}].quantity`} type="number" bottom={0} />
            <Input
              name={`items[${index}].discountValue`}
              type="number"
              bottom={0}
            />
            <Typography className={classes.right}>
              {formatMoney(getAmount(item, priceKey))}
            </Typography>
            <IconButton
              color="inherit"
              edge="start"
              onClick={() => remove(index)}
            >
              <ClearIcon fontSize="small" />
            </IconButton>
          </div>

          <Divider />
        </React.Fragment>
      ))}

      <div className={classes.buttonContainer}>
        <Button
          color="primary"
          onClick={() =>
            push({
              quantity: 0,
              discountType: discountPolicy,
              discountValue: 0,
            })
          }
          startIcon={<AddIcon />}
        >
          Add Lines
        </Button>
      </div>
    </div>
  );
}

function DiscountPicker({ onChange }) {
  const classes = useStyles();
  const prefs = usePrefs();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectedPolicy, setSelectedPolicy] = React.useState("percent");

  const label = selectedPolicy === "value" ? "Disc" : "Disc (%)";

  React.useEffect(() => {
    if (prefs) setSelectedPolicy(prefs?.discountPolicy);
  }, [prefs]);

  React.useEffect(() => {
    if (selectedPolicy) onChange?.(selectedPolicy);
    // eslint-disable-next-line
  }, [selectedPolicy]);

  const onOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const onClose = () => {
    setAnchorEl(null);
  };

  const onSelected = (value) => {
    setSelectedPolicy(value);
    setAnchorEl(null);
  };

  return (
    <>
      <div className={classes.discountPickerRoot} onClick={onOpen}>
        <Typography variant="button">{label}</Typography>
        <Icon>arrow_drop_down</Icon>
      </div>

      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={onClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <List dense disablePadding>
          <ListItem button onClick={() => onSelected("percent")}>
            <ListItemText>Percentage</ListItemText>
          </ListItem>
          <Divider />
          <ListItem button onClick={() => onSelected("value")}>
            <ListItemText>Value</ListItemText>
          </ListItem>
        </List>
      </Popover>
    </>
  );
}
